import { render, staticRenderFns } from "./Salas.vue?vue&type=template&id=fdfad160&scoped=true"
import script from "./Salas.vue?vue&type=script&lang=ts"
export * from "./Salas.vue?vue&type=script&lang=ts"
import style0 from "./Salas.vue?vue&type=style&index=0&id=fdfad160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfad160",
  null
  
)

export default component.exports